module.exports = __webpack_public_path__ + "img/feedback9-2.0535b4f4.jpg";